import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../../utils/loadable';

const heading = Loadable(() => import('../../containers/web/cartHeading'));
export default MapTo('vcg/components/soe-home/react/cart/heading')(heading);
